import styled from 'styled-components';

export const StoreWrapper = styled.div`
  margin-bottom: 1.5rem;
`;
export const ModalContentWrapper = styled.div`
  max-height: 50vh;
  overflow-y: auto;
  margin-bottom: 1rem;
`;

export const CenterWrapper = styled.div`
  padding-top: 2.8125rem;
  display: flex;
  justify-content: center;
`;
